<template>
  <section id="coming-soon">
    <v-parallax
      dark
      :height="minHeight"
      :src="require('@/assets/pattern-6.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <!-- <v-img
      :min-height="minHeight"
      :src="require('@/assets/home-hero.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    > -->
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-start"
          height="20%"
          width="100%"
        />
        <v-responsive
          class="d-flex align-start"
          height="100%"
          width="100%"
        >
          <v-row justify="right">
            <v-col>
              <base-heading title="Equity Transformed" />
            </v-col>
          </v-row>

          <base-body>
            Experience Equity Unleashed.  Coming soon...
          </base-body>
        </v-responsive>
        <v-responsive
          class="d-flex align-center"
          height="100%"
          width="20%"
        />
        <v-responsive
          class="d-flex align-start float-right"
          height="100%"
          width="40%"
        />
      </v-container>
    </v-parallax>
  </section>
</template>

<script>
  import AnimatedNumber from 'animated-number-vue'

  export default {
    name: 'SectionComingSoon',

    components: {
      AnimatedNumber,
      TokenSummaryCard: () => import('@/components/TokenSummaryCard'),
    },

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeightFormatted () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },

      minHeight () {
        return this.$vuetify.breakpoint.height > 800 ? this.$vuetify.breakpoint.height : 800
      },

    },
    methods: {
      numberWithCommas (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
    },
  }
</script>
